<template>
  <div class="product-alert" v-show="visible">
    <div class="container">
      <img @click="visible = false" src="/cdn/images/temp/close.svg" class="close" alt />

      <img src="/cdn/images/temp/Info.svg" class="info" alt />
      <h4>{{ label_import_information }}</h4>
      <p class="product-alert-link" v-html="data"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "product-alert",
  props: {
    data: {
      type: String
    },
    label_import_information: {
      type: String,
      required: true,
      default: "Important information"
    }
  },
  data() {
    return {
      visible: true
    };
  }
};
</script>
